import React, { useEffect, useState } from 'react'
import { Button, DatePicker, Input, Select, Spin, Table } from 'antd'
import 'aos/dist/aos.css'
import '../MainCSS.css'
import { Option } from 'antd/es/mentions'
import axios from 'axios'
import { toast } from 'react-toastify'
import {
  GetAgeingNoData,
  GetAgeingReportData,
  GetAgeingReportDataExcel,
} from '../../AllAPI/ProductionReportAPI/ProductionReportApi'
import dayjs from 'dayjs'
import { BaseIPForPDF } from '../../AllAPI/CommonAPI/CommonApi'

const AgeingReport = () => {

  const commonHeaders1 = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
    },
  }

  const [errors, setErrors] = useState({
    ageingNo: '',
    date: '',
    startDate: '',
    endDate: '',
  })

  const [ageingNo, setAgeingNo] = useState('')
  const [date, setDate] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [loading, setLoading] = useState(false)

  const [allAgeingNo, setAllAgeingNo] = useState([])
  const [allAgeingReportData, setAllAgeingReportData] = useState([])

  //======Search data from table===============

  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)

  const handleSearch = (value) => {
    const searchValue = value.toLowerCase()

    const filtered = allAgeingReportData.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? '')
          .toLowerCase()
          .includes(searchValue),
      ),
    )

    setFilteredData(filtered)
    setTotalEntries(filtered.length)
    setCurrentPage(1)
  }
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

  // Fetch Ageing Report Data
  let isAgeingFetched = false
  useEffect(() => {
    if (isAgeingFetched) return
    fetchAgeingNo()
    isAgeingFetched = true
  }, [])

  // ==============Get table data================

  let isError = false

  const columns = [
    {
      title: 'Sr.No.',
      dataIndex: '',
      key: 'index',
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Ageing No.',
      dataIndex: 'ageingNumber',
      key: 'ageingNumber',
    },
    {
      title: 'Date',
      dataIndex: 'ageingDate',
      key: 'ageingDate',
    },
    {
      title: 'Total Rack',
      dataIndex: 'totalRackCount',
      key: 'totalRackCount',
    },
    {
      title: 'Start Time',
      dataIndex: 'startTime',
      key: 'startTime',
    },
    {
      title: 'Temp Achieve Time',
      dataIndex: 'temperatureAchieveTime',
      key: 'temperatureAchieveTime',
    },
    {
      title: 'Out Time',
      dataIndex: 'outTime',
      key: 'outTime',
    },
    {
      title: 'Remarks',
      dataIndex: 'remark',
      key: 'remark',
    },
    // {
    //   title: "Actions",
    //   key: "actions",
    //   render: (text, record) => (
    //     <div>
    //       <span
    //         type="submit"
    //         style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
    //         onClick={() => handleEditDataButton(record)}
    //       >
    //         <i class="fa-solid fa-pen-to-square"></i>
    //       </span>
    //       <span
    //         type="submit"
    //         style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
    //         onClick={() => handleDeleteData(record)}
    //       >
    //         <i class="fa-solid fa-trash"></i>
    //       </span>
    //     </div>
    //   ),
    // },
  ]

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023E7D',
            color: '#fff',
            padding: '10px',
            fontSize: '13px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
          }}
        >
          {children}
        </td>
      ),
    },
  }

  const fetchAgeingNo = async () => {
    try {
      const response = await axios.get(GetAgeingNoData, commonHeaders1)
      if (response.data !== null) {
        setAllAgeingNo(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Ageing No:', error)
        toast.error('Failed to fetch Ageing No data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  //=========CANCEL EMPLOYEE DATA============
  const handleCancel = () => {
    setAllAgeingReportData([0])
    setAgeingNo('')
    setDate('')
    setStartDate('')
    setEndDate('')
    setErrors('')
  }

  //=========GET AGEING REPORT DATA============

  const handleSubmit = async () => {
    let isValid = true
    const errorObj = {}

    // Validation
    if (!ageingNo && !date && !startDate && !endDate) {
      isValid = false
      toast.error('Please provide at least one field')
      return
    }

    if (startDate && !endDate) {
      isValid = false
      errorObj.endDate = 'End Date is required when Start Date is provided *'
    }

    if (endDate && !startDate) {
      isValid = false
      errorObj.startDate = 'Start Date is required when End Date is provided *'
    }

    setErrors(errorObj)
    if (!isValid) return

    // Format dates
    const formattedDate = date ? dayjs(date).format('DD/MM/YYYY') : ''
    const formattedStartDate = startDate
      ? dayjs(startDate).format('DD/MM/YYYY')
      : ''
    const formattedEndDate = endDate ? dayjs(endDate).format('DD/MM/YYYY') : ''

    const queryParams = []

    if (ageingNo) queryParams.push(`id=${ageingNo}`)
    if (formattedDate) queryParams.push(`date=${formattedDate}`)
    if (formattedStartDate) queryParams.push(`startDate=${formattedStartDate}`)
    if (formattedEndDate) queryParams.push(`endDate=${formattedEndDate}`)

    const url = `${GetAgeingReportData}?${queryParams.join('&')}`

    try {
      const response = await axios.get(url, commonHeaders1)
      if (response.data !== null) {
        setAllAgeingReportData(response.data)
        setFilteredData(response.data)
        setTotalEntries(response.data.length)
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
  }

  const handleShowExcel = async () => {
    let isValid = true
    const errorObj = {}

    // Validation
    if (!ageingNo && !date && !startDate && !endDate) {
      isValid = false
      toast.error('Please provide at least one field')
      return
    }

    if (startDate && !endDate) {
      isValid = false
      errorObj.endDate = 'End Date is required when Start Date is provided *'
    }

    if (endDate && !startDate) {
      isValid = false
      errorObj.startDate = 'Start Date is required when End Date is provided *'
    }

    setErrors(errorObj)
    if (!isValid) return

    // Format dates
    const formattedDate = date ? dayjs(date).format('DD/MM/YYYY') : ''
    const formattedStartDate = startDate
      ? dayjs(startDate).format('DD/MM/YYYY')
      : ''
    const formattedEndDate = endDate ? dayjs(endDate).format('DD/MM/YYYY') : ''

    const queryParams = []
    if (ageingNo) queryParams.push(`id=${ageingNo}`)
    if (formattedDate) queryParams.push(`date=${formattedDate}`)
    if (formattedStartDate) queryParams.push(`startDate=${formattedStartDate}`)
    if (formattedEndDate) queryParams.push(`endDate=${formattedEndDate}`)

    const url = `${GetAgeingReportDataExcel}?${queryParams.join('&')}`

    try {
      const response = await axios.get(url, commonHeaders1)

      if (response.data !== null) {
        if (
          response.data === 'NOTFOUND' ||
          response.data === 'NODATA' ||
          response.status === 204
        ) {
          toast.warn('No data available!', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })

          setLoading(false)
          return // Exit function early
        }
  
        let reportUrl = response.data
        if (reportUrl === 'NOTFOUND') {
          toast.warn('Report File Not Found...!!', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
        } else {
          const reportLink = BaseIPForPDF + `output/${reportUrl}`
          window.open(reportLink, '_blank')
        }
      }
    } catch (error) {
      setLoading(false)
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
  }

  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY']
  //==============================================================================

  return (
    <>
      <div className="px-5 py-3">
        <div
          className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
          style={{ backgroundColor: '#e0efff' }}
        >
          

          <div className="col-12">
            <div className="row px-md-5 mt-3 p-2">
              <div className="col-12 col-lg-3"></div>
              <div className="col-12 col-lg-6">
                <div className="row p-0 m-0">
                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">Ageing No.</label>
                    <Select
                      value={ageingNo || undefined}
                      onChange={setAgeingNo}
                      showSearch
                      className="w-100"
                      placeholder="Select Ageing No."
                      optionFilterProp="children"
                    >
                      {allAgeingNo.map((ageing) => (
                        <Option key={ageing.id} value={ageing.id}>
                          {ageing.ageingNumber}
                        </Option>
                      ))}
                    </Select>
                    {errors.ageingNo && (
                      <div className="errorField">{errors.ageingNo}</div>
                    )}
                  </div>
                  <div className="col-md-6 col-lg-6 py-1"></div>

                  <div
                    className="col-12 text-center"
                    style={{ fontSize: 'small' }}
                  >
                    OR
                  </div>

                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">Date</label>
                    <DatePicker
                      className="w-100"
                      format={dateFormatList}
                      value={date}
                      onChange={(value) => setDate(value)}
                    />
                    {errors.date && (
                      <div className="errorField">{errors.date}</div>
                    )}
                  </div>
                  <div className="col-md-6 col-lg-6 py-1"></div>

                  <div
                    className="col-12 text-center"
                    style={{ fontSize: 'small' }}
                  >
                    OR
                  </div>

                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">Date Range Start</label>
                    <DatePicker
                      className="w-100"
                      format={dateFormatList}
                      value={startDate}
                      onChange={(value) => setStartDate(value)}
                    />
                    {errors.date && (
                      <div className="errorField">{errors.date}</div>
                    )}
                  </div>

                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">Date Range End</label>
                    <DatePicker
                      className="w-100"
                      format={dateFormatList}
                      value={endDate}
                      onChange={(value) => setEndDate(value)}
                    />
                    {errors.endDate && (
                      <div className="errorField">{errors.endDate}</div>
                    )}
                  </div>
                </div>

                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </div>
              </div>
              <div className="col-12 col-lg-3"></div>

              <div
                className="col-12 p-0 mt-3"
                style={{ borderBottom: '2px solid rgb(207, 207, 207)' }}
              ></div>
            </div>

            {/*================ Table =========================*/}
            <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
              <div
                className="col-12 py-3 shadow border"
                style={{ backgroundColor: 'white' }}
              >
                <div className="row ps-2 m-0 mb-2">
                  <div className="col-12 col-md-3">
                    <Button
                      onClick={handleShowExcel}
                      style={{ backgroundColor: '#f8bf28' }}
                      disabled={loading}
                    >
                       {loading ? "Generating Excel..." : "Export to Excel"}
                    </Button>
                  </div>
                </div>

                <div
                  className="col-12 px-md-5"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <span style={{ fontSize: '14px' }}>
                      Show entries &nbsp;
                    </span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: 'center' }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>

                <div style={{ backgroundColor: 'white' }}>
                  <Table
                    bordered
                    style={{ padding: '0px 20px', overflowX: 'auto' }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AgeingReport
